import { createClient } from '@supabase/supabase-js';

// Shared Supabase project with the marketplace app — an account created in
// either app signs in to both. URL + anon (publishable) key are safe to ship
// to the browser; they are gated by Supabase Auth + RLS, not secret.
const SUPABASE_URL =
  process.env.REACT_APP_SUPABASE_URL || 'https://vhoaarzduvwuikfdgikr.supabase.co';
const SUPABASE_ANON_KEY =
  process.env.REACT_APP_SUPABASE_ANON_KEY || 'sb_publishable_W0iVnie2ziqLzDz3v_XuCQ_GlDe5rZ-';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true, // handles OAuth / email-confirm redirects
  },
});
